var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("CriterionDetailsDialog", {
        attrs: { viewModel: _vm.criterionDetailsDialog },
      }),
      _vm._v(" "),
      _vm.initialized === false ? [_vm._m(0)] : _vm._e(),
      _vm._v(" "),
      _vm.initialized === true
        ? _c("div", { staticClass: "container" }, [
            _c(
              "nav",
              { staticClass: "navbar fixed-bottom navbar-dark bg-dark" },
              [
                _c(
                  "div",
                  { staticClass: "container d-flex justify-content-center" },
                  [
                    _c(
                      "div",
                      { staticClass: "btn-group", attrs: { role: "group" } },
                      [
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "sanitizedHref",
                                rawName: "v-sanitizedHref",
                                value: _vm.rm.PrevContextUrl,
                                expression: "rm.PrevContextUrl",
                              },
                            ],
                            staticClass: "btn btn-secondary",
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-angle-double-left",
                              attrs: { "aria-hidden": "true" },
                            }),
                            _vm._v(" Prev "),
                            _c("span", { staticClass: "d-none d-sm-inline" }, [
                              _vm._v("criterion"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-warning",
                            attrs: { type: "button" },
                            on: { click: _vm.scrollTop },
                          },
                          [_vm._v("Back to Top")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "sanitizedHref",
                                rawName: "v-sanitizedHref",
                                value: _vm.rm.NextContextUrl,
                                expression: "rm.NextContextUrl",
                              },
                            ],
                            staticClass: "btn btn-secondary",
                          },
                          [
                            _vm._v("\n                        Next "),
                            _c("span", { staticClass: "d-none d-sm-inline" }, [
                              _vm._v("criterion"),
                            ]),
                            _vm._v(" "),
                            _c("i", {
                              staticClass: "fa fa-angle-double-right",
                              attrs: { "aria-hidden": "true" },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "nav",
              {
                staticClass:
                  "navbar navbar-expand-md navbar-dark bg-dark fixed-top",
              },
              [
                _c("div", { staticClass: "container" }, [
                  _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "sanitizedHref",
                          rawName: "v-sanitizedHref",
                          value: _vm.rm.DashboardUrl,
                          expression: "rm.DashboardUrl",
                        },
                      ],
                      staticClass: "btn btn-light mr-auto",
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-angle-double-left",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(
                        "\n                    My Survey\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "progress mx-2 w-50",
                      staticStyle: {
                        height: "38px",
                        "background-color": "#D3D3D3",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "progress-bar",
                          style: { width: _vm.Progress + "%" },
                          attrs: { role: "progressbar" },
                        },
                        [_vm._v(_vm._s(_vm.ProgressStr))]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.IsSaved == null
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-warning",
                          attrs: { type: "button" },
                          on: {
                            click: _vm.handleSavePanelistCriterionVotesCommand,
                          },
                        },
                        [
                          _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                          _vm._v(" Saving...\n                "),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.IsSaved === true
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-light",
                          attrs: { type: "button" },
                          on: {
                            click: _vm.handleSavePanelistCriterionVotesCommand,
                          },
                        },
                        [
                          _vm._v(
                            "\n                    Saved\n                "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.IsSaved === false
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-warning",
                          attrs: { type: "button" },
                          on: {
                            click: _vm.handleSavePanelistCriterionVotesCommand,
                          },
                        },
                        [_vm._v("\n                    Save\n                ")]
                      )
                    : _vm._e(),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  "padding-top": "80px",
                  "padding-bottom": "120px",
                },
              },
              [
                _c("h3", { staticClass: "mt-4", attrs: { id: "top" } }, [
                  _c("span", { staticClass: "font-weight-light" }, [
                    _vm._v("Compare criteria in the context of:"),
                  ]),
                  _vm._v(" " + _vm._s(_vm.rm.Name) + "\n            "),
                ]),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c(
                  "nav",
                  {
                    staticClass:
                      "navbar navbar-expand-md navbar-light bg-light",
                  },
                  [
                    _c("ul", { staticClass: "navbar-nav" }, [
                      _c("li", { staticClass: "nav-item dropdown" }, [
                        _c(
                          "a",
                          {
                            staticClass: "nav-link dropdown-toggle",
                            attrs: {
                              role: "button",
                              "data-toggle": "dropdown",
                            },
                          },
                          [
                            _vm._v(
                              "\n                            Questions: " +
                                _vm._s(_vm.questionsFilter ?? "All") +
                                "\n                        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "dropdown-menu" }, [
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item",
                              on: {
                                click: function ($event) {
                                  _vm.questionsFilter = null
                                },
                              },
                            },
                            [
                              _vm._v("All "),
                              _c(
                                "span",
                                { staticClass: "badge badge-secondary" },
                                [_vm._v(_vm._s(_vm.QuestionsCount))]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "dropdown-divider" }),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item",
                              on: {
                                click: function ($event) {
                                  _vm.questionsFilter = "Answered"
                                },
                              },
                            },
                            [
                              _vm._v("Answered "),
                              _c(
                                "span",
                                { staticClass: "badge badge-secondary" },
                                [_vm._v(_vm._s(_vm.AnsweredQuestionsCount))]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item",
                              on: {
                                click: function ($event) {
                                  _vm.questionsFilter = "Not answered"
                                },
                              },
                            },
                            [
                              _vm._v("Not answered "),
                              _c(
                                "span",
                                { staticClass: "badge badge-secondary" },
                                [_vm._v(_vm._s(_vm.NotAnsweredQuestionsCount))]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "dropdown-divider" }),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item",
                              on: {
                                click: function ($event) {
                                  _vm.questionsFilter = "Commented"
                                },
                              },
                            },
                            [
                              _vm._v("Commented "),
                              _c(
                                "span",
                                { staticClass: "badge badge-secondary" },
                                [_vm._v(_vm._s(_vm.CommentedQuestionsCount))]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item",
                              on: {
                                click: function ($event) {
                                  _vm.questionsFilter = "Not commented"
                                },
                              },
                            },
                            [
                              _vm._v("Not commented "),
                              _c(
                                "span",
                                { staticClass: "badge badge-secondary" },
                                [_vm._v(_vm._s(_vm.NotCommentedQuestionsCount))]
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "nav-item dropdown" }, [
                        _c(
                          "a",
                          {
                            staticClass: "nav-link dropdown-toggle",
                            attrs: {
                              role: "button",
                              "data-toggle": "dropdown",
                            },
                            on: { click: _vm.loadConsistencyAnalysis },
                          },
                          [
                            _vm._v(
                              "\n                            Most inconsistent\n                        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "dropdown-menu" },
                          [
                            _vm.rm.ConsistencyAnalysis == null
                              ? [_vm._m(1)]
                              : [
                                  _vm.InsufficientData === true
                                    ? [
                                        _c("p", { staticClass: "px-2" }, [
                                          _vm._v(
                                            "Not enough answers to check consistency"
                                          ),
                                        ]),
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.IsConsistent === true
                                    ? [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "dropdown-item",
                                            on: {
                                              click:
                                                _vm.showConsistencyAnalysisLegend,
                                            },
                                          },
                                          [
                                            _vm._m(2),
                                            _vm._v(
                                              "\n                                        Inconsistency score: " +
                                                _vm._s(
                                                  _vm.rm.ConsistencyAnalysis.CR
                                                ) +
                                                "%\n                                    "
                                            ),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.IsAcceptable === true
                                    ? [
                                        _vm._l(
                                          _vm.MostInconsistent,
                                          function (q) {
                                            return _c(
                                              "a",
                                              {
                                                key: q.Id,
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.highlightQuestion(
                                                      q
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(q.Name1) +
                                                    " vs. " +
                                                    _vm._s(q.Name2) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "dropdown-divider",
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass: "dropdown-item",
                                            on: {
                                              click:
                                                _vm.showConsistencyAnalysisLegend,
                                            },
                                          },
                                          [
                                            _vm._m(3),
                                            _vm._v(
                                              "\n                                        Inconsistency score: " +
                                                _vm._s(
                                                  _vm.rm.ConsistencyAnalysis.CR
                                                ) +
                                                "%\n                                    "
                                            ),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.IsInconsistent === true
                                    ? [
                                        _vm._l(
                                          _vm.MostInconsistent,
                                          function (q) {
                                            return _c(
                                              "a",
                                              {
                                                key: q.Id,
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.highlightQuestion(
                                                      q
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(q.Name1) +
                                                    " vs. " +
                                                    _vm._s(q.Name2) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "dropdown-divider",
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass: "dropdown-item",
                                            on: {
                                              click:
                                                _vm.showConsistencyAnalysisLegend,
                                            },
                                          },
                                          [
                                            _vm._m(4),
                                            _vm._v(
                                              "\n                                        Inconsistency score: " +
                                                _vm._s(
                                                  _vm.rm.ConsistencyAnalysis.CR
                                                ) +
                                                "%\n                                    "
                                            ),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                          ],
                          2
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "form",
                      { staticClass: "form-inline my-2 my-lg-0 ml-auto" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.searchPhrase,
                              expression: "searchPhrase",
                            },
                          ],
                          staticClass: "form-control mr-sm-2",
                          attrs: { type: "search", placeholder: "Filter..." },
                          domProps: { value: _vm.searchPhrase },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.searchPhrase = $event.target.value
                            },
                          },
                        }),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm._l(_vm.QuestionsView, function (q) {
                  return _c(
                    "div",
                    {
                      key: q.QuestionId,
                      staticClass: "row justify-content-start",
                      attrs: { id: _vm.getDomId(q) },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "col-md-8 col-sm-12",
                          class: { "bg-warning": q.Highlighted },
                        },
                        [
                          _c("p", { staticClass: "mt-5 mb-3 lead" }, [
                            _c("strong", [_vm._v(_vm._s(q.OrderValue) + ".")]),
                            _vm._v(
                              "\n                        In the context of "
                            ),
                            _c(
                              "a",
                              {
                                staticClass: "text-dark font-italic",
                                on: {
                                  click: function ($event) {
                                    return _vm.showCriterionDetails(
                                      _vm.rm.Name,
                                      _vm.rm.Path,
                                      _vm.rm.Description
                                    )
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.rm.Name))]
                            ),
                            _vm._v(
                              ",\n                        which criterion is more important: "
                            ),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "text-primary",
                                on: {
                                  click: function ($event) {
                                    return _vm.showCriterionDetails(
                                      q.Name1,
                                      q.Path1,
                                      q.Description1
                                    )
                                  },
                                },
                              },
                              [_vm._v(_vm._s(q.Name1))]
                            ),
                            _vm._v(" or\n                        "),
                            _c(
                              "a",
                              {
                                staticClass: "text-primary",
                                on: {
                                  click: function ($event) {
                                    return _vm.showCriterionDetails(
                                      q.Name2,
                                      q.Path2,
                                      q.Description2
                                    )
                                  },
                                },
                              },
                              [_vm._v(_vm._s(q.Name2))]
                            ),
                            _vm._v("?\n                    "),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c(
                              "div",
                              {
                                staticClass: "btn-group-vertical d-flex",
                                attrs: { role: "group" },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "btn-group",
                                    attrs: { role: "group" },
                                  },
                                  [
                                    q.Value > 1.0
                                      ? [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn text-left btn-primary",
                                              staticStyle: {
                                                padding: "0.75rem 1.25rem",
                                              },
                                              attrs: {
                                                type: "button",
                                                "data-toggle": "dropdown",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "badge badge-pill badge-light text-primary",
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-check",
                                                    attrs: {
                                                      "aria-hidden": "true",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getScaleLabel(
                                                          q.Value
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(_vm._s(q.Name1)),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "dropdown-menu" },
                                            [
                                              _c(
                                                "h4",
                                                {
                                                  staticClass:
                                                    "dropdown-header",
                                                },
                                                [
                                                  _vm._v(
                                                    "How much more important?"
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass: "dropdown-divider",
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.SetValueCommand(
                                                        q,
                                                        2
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Weak")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.SetValueCommand(
                                                        q,
                                                        3
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Moderate")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.SetValueCommand(
                                                        q,
                                                        4
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Moderate +")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.SetValueCommand(
                                                        q,
                                                        5
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Strong")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.SetValueCommand(
                                                        q,
                                                        6
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Strong +")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.SetValueCommand(
                                                        q,
                                                        7
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Very strong")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.SetValueCommand(
                                                        q,
                                                        8
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Very strong +")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.SetValueCommand(
                                                        q,
                                                        9
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Extreme")]
                                              ),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass: "dropdown-divider",
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.SetValueCommand(
                                                        q,
                                                        null
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fa fa-times text-danger",
                                                    attrs: {
                                                      "aria-hidden": "true",
                                                    },
                                                  }),
                                                  _vm._v(
                                                    "\n                                            Clear\n                                        "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      : [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn text-left btn-outline-secondary",
                                              staticStyle: {
                                                padding: "0.75rem 1.25rem",
                                              },
                                              attrs: {
                                                type: "button",
                                                "data-toggle": "dropdown",
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fa fa-circle-thin",
                                                attrs: {
                                                  "aria-hidden": "true",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(_vm._s(q.Name1)),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "dropdown-menu" },
                                            [
                                              _c(
                                                "h4",
                                                {
                                                  staticClass:
                                                    "dropdown-header",
                                                },
                                                [
                                                  _vm._v(
                                                    "How much more important?"
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass: "dropdown-divider",
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.SetValueCommand(
                                                        q,
                                                        2
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Weak")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.SetValueCommand(
                                                        q,
                                                        3
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Moderate")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.SetValueCommand(
                                                        q,
                                                        4
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Moderate +")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.SetValueCommand(
                                                        q,
                                                        5
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Strong")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.SetValueCommand(
                                                        q,
                                                        6
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Strong +")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.SetValueCommand(
                                                        q,
                                                        7
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Very strong")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.SetValueCommand(
                                                        q,
                                                        8
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Very strong +")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.SetValueCommand(
                                                        q,
                                                        9
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Extreme")]
                                              ),
                                            ]
                                          ),
                                        ],
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                q.Value === 1.0
                                  ? [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-primary text-left",
                                          staticStyle: {
                                            padding: "0.75rem 1.25rem",
                                          },
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.SetValueCommand(
                                                q,
                                                null
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-check-circle",
                                          }),
                                          _vm._v(
                                            " Equally important\n                                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  : [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-outline-secondary text-left",
                                          staticStyle: {
                                            padding: "0.75rem 1.25rem",
                                          },
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.SetValueCommand(q, 1.0)
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-circle-thin",
                                          }),
                                          _vm._v(
                                            " Equally important\n                                "
                                          ),
                                        ]
                                      ),
                                    ],
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "btn-group",
                                    attrs: { role: "group" },
                                  },
                                  [
                                    q.Value != null && q.Value < 1.0
                                      ? [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-primary text-left",
                                              staticStyle: {
                                                padding: "0.75rem 1.25rem",
                                              },
                                              attrs: {
                                                type: "button",
                                                "data-toggle": "dropdown",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "badge badge-pill badge-light text-primary",
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-check",
                                                    attrs: {
                                                      "aria-hidden": "true",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getScaleLabel(
                                                          q.Value
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(_vm._s(q.Name2)),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "dropdown-menu" },
                                            [
                                              _c(
                                                "h4",
                                                {
                                                  staticClass:
                                                    "dropdown-header",
                                                },
                                                [
                                                  _vm._v(
                                                    "How much more important?"
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass: "dropdown-divider",
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.SetValueCommand(
                                                        q,
                                                        1.0 / 2.0
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Weak")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.SetValueCommand(
                                                        q,
                                                        1.0 / 3.0
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Moderate")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.SetValueCommand(
                                                        q,
                                                        1.0 / 4.0
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Moderate +")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.SetValueCommand(
                                                        q,
                                                        1.0 / 5.0
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Strong")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.SetValueCommand(
                                                        q,
                                                        1.0 / 6.0
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Strong +")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.SetValueCommand(
                                                        q,
                                                        1.0 / 7.0
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Very strong")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.SetValueCommand(
                                                        q,
                                                        1.0 / 8.0
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Very strong +")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.SetValueCommand(
                                                        q,
                                                        1.0 / 9.0
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Extreme")]
                                              ),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass: "dropdown-divider",
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.SetValueCommand(
                                                        q,
                                                        null
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fa fa-times text-danger",
                                                    attrs: {
                                                      "aria-hidden": "true",
                                                    },
                                                  }),
                                                  _vm._v(
                                                    "\n                                            Clear\n                                        "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      : [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-outline-secondary text-left",
                                              staticStyle: {
                                                padding: "0.75rem 1.25rem",
                                              },
                                              attrs: {
                                                type: "button",
                                                "data-toggle": "dropdown",
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fa fa-circle-thin",
                                                attrs: {
                                                  "aria-hidden": "true",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(_vm._s(q.Name2)),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "dropdown-menu" },
                                            [
                                              _c(
                                                "h4",
                                                {
                                                  staticClass:
                                                    "dropdown-header",
                                                },
                                                [
                                                  _vm._v(
                                                    "How much more important?"
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass: "dropdown-divider",
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.SetValueCommand(
                                                        q,
                                                        1.0 / 2.0
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Weak")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.SetValueCommand(
                                                        q,
                                                        1.0 / 3.0
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Moderate")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.SetValueCommand(
                                                        q,
                                                        1.0 / 4.0
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Moderate +")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.SetValueCommand(
                                                        q,
                                                        1.0 / 5.0
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Strong")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.SetValueCommand(
                                                        q,
                                                        1.0 / 6.0
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Strong +")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.SetValueCommand(
                                                        q,
                                                        1.0 / 7.0
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Very strong")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.SetValueCommand(
                                                        q,
                                                        1.0 / 8.0
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Very strong +")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.SetValueCommand(
                                                        q,
                                                        1.0 / 9.0
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Extreme")]
                                              ),
                                            ]
                                          ),
                                        ],
                                  ],
                                  2
                                ),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("textarea", {
                              staticClass: "form-control my-3",
                              attrs: { rows: "3", placeholder: "Comment..." },
                              domProps: { value: q.Comment },
                              on: {
                                input: function ($event) {
                                  return _vm.setComment($event.target.value, q)
                                },
                              },
                            }),
                          ]),
                        ]
                      ),
                    ]
                  )
                }),
              ],
              2
            ),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "container" }, [
      _c("h3", { staticClass: "text-center" }, [
        _c("i", { staticClass: "fa fa-spinner fa-spin" }),
        _vm._v(" Loading..."),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", { staticClass: "m-4" }, [
      _c("i", { staticClass: "fa fa-spinner fa-spin" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "fa-stack fa-lg fa-stack-sm" }, [
      _c("i", { staticClass: "fa fa-circle fa-stack-1x text-success" }),
      _vm._v(" "),
      _c("i", { staticClass: "fa-regular fa-face-smile fa-stack-1x" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "fa-stack fa-lg fa-stack-sm" }, [
      _c("i", { staticClass: "fa fa-circle fa-stack-1x text-warning" }),
      _vm._v(" "),
      _c("i", { staticClass: "fa-regular fa-face-meh fa-stack-1x" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "fa-stack fa-lg fa-stack-sm" }, [
      _c("i", { staticClass: "fa fa-circle fa-stack-1x text-danger" }),
      _vm._v(" "),
      _c("i", { staticClass: "fa-regular fa-face-frown fa-stack-1x" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }